export default __webpack_public_path__ + "static/media/worry-tree.1f125f5c.jpg";